module.exports = __webpack_public_path__ + "static/img/h6.b2a7ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/h6.jpg
// module id = lweH
// module chunks = 0